import React, { Component, Fragment } from "react";
import clsx from "clsx";

import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";

import {
  MAIN_COLORS,
  Error,
  selectFormat,
  StandardTooltip,
} from "./../Utils/Utils.js";

class PieChartLegends extends Component {
  constructor(props) {
    super(props);
    this.renderCell = this.renderCell.bind(this);
  }

  renderCell(entry, index) {
    return <Cell key={index} fill={MAIN_COLORS[index % MAIN_COLORS.length]} />;
  }

  renderPercentage(data) {
    const total = data.reduce((s, e) => s + e.value, 0);
    const sorted = data.sort((a, b) => a.value - b.value);

    sorted.reverse();

    return sorted.map((e, key) => {
      if (((e.value * 100) / total).toFixed(0) > 0) {
        // prevent 0%
        return (
          <div className="text-left mb-1" key={e.name}>
            <span
              className="pr-1"
              style={{ color: MAIN_COLORS[key % MAIN_COLORS.length] }}
            >
              {((e.value * 100) / total).toFixed(0)}%
            </span>
            <span className="text-capitalize">{e.name}</span>
          </div>
        );
      } else {
        return null;
      }
    });
  }

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row">
        <div className="col-6 pt-3">
          <ResponsiveContainer height={270}>
            <PieChart>
              <Pie
                data={data.data}
                dataKey="value"
                innerRadius={"55%"}
                outerRadius={"100%"}
              >
                {data.data.map(this.renderCell)}
              </Pie>

              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(data.graph);
                      if (payload !== null) {
                        const total = this.props.data.data.reduce(
                          (s, e) => s + e.value,
                          0
                        );

                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {this.props.title}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              {Object.keys(payload)
                                .sort(
                                  (a, b) => payload[b].value - payload[a].value
                                )
                                .filter((key) => payload[key].value > 0)
                                .map((key, index) => (
                                  <Fragment key={key}>
                                    <div className="standard-tooltip__item">
                                      <span
                                        className={clsx(
                                          "standard-tooltip__key",
                                          "text-capitalize"
                                        )}
                                        style={{
                                          color: payload[key].payload.fill,
                                        }}
                                      >
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background:
                                              payload[key].payload.fill,
                                          }}
                                        ></span>
                                        {payload[key].payload.name}
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {(
                                          (payload[key].payload.value * 100) /
                                          total
                                        ).toFixed(0)}
                                        % (
                                        {selectFormat(
                                          "number",
                                          payload[key].payload.value
                                        )}
                                        )
                                      </span>
                                    </div>
                                  </Fragment>
                                ))}
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="col-6 d-flex flex-column justify-content-center">
          {this.renderPercentage(data.data)}
        </div>
      </div>
    );
  }
}

export default PieChartLegends;
